import { Autocomplete, Box, Button, Unstable_Grid2 as Grid, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Database } from "../../../data/interfaces/settingsmodel";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import { updatedatabase, updatetoc,updateenvironment } from "../../../stores/settingsslice";
import settingsService from "../../../data/api/settings.service";
import Alert from "@mui/material";
import { closeEnvSettingDialog } from "../../../stores/envsettingdialogslice";
import { showsuccessmessage } from "../../../stores/notificationslice";
import { RootState } from "../../../stores/store";

import { reset as magneticreset } from "../../../stores/magneticslice";
import { reset as itsoreset } from "../../../stores/itsoslice";
import { ReloadStateContext } from "../../../layout/main";
import userService from "../../../data/api/user.service";
export default function EnvironementSettings() {
    const{reloadCounter,setReloadCounter}=useContext(ReloadStateContext);
    const [tocs, setTocs] = useState<DropdownModel[]>([]);
    const dispatch=useAppDispatch();
    const [toc,setToc]=useState<DropdownModel|null>(null);
    const isEnvSettingDialogOpen = useAppSelector((state:RootState) => state.envSettingDialogReducer.isEnvSettingDialogOpen);
  
    useEffect(() => {
        userService.isCubicUser().then((response)=>{
            if(response&&response.data){
                settingsService.gettocs().then((response)=>{
                    setTocs(response.data);
                });
            }
        });
        
    }, []);

    useEffect(()=>{
        if(tocs.length>0){
            let tocFromStorage=localStorage.getItem('Toc');
            if(tocFromStorage){
                setToc(JSON.parse(tocFromStorage));
            }
            else{
                setToc(tocs[0]);
            }
        }
        else{
            setToc(null);
        }
    },[tocs]);

    

    const saveEnvironment=()=>{

        if(toc){
            let tocString=JSON.stringify(toc);
            localStorage.setItem('Toc',tocString);
            dispatch(updatetoc(toc));
        }
       
        
        if(isEnvSettingDialogOpen){
        dispatch(closeEnvSettingDialog());

        }
        dispatch(magneticreset);
        dispatch(itsoreset);
        setReloadCounter(reloadCounter+1);
        dispatch(showsuccessmessage("TOC changed to '"+toc?.Description+"' Successfully!"));
    }


    return (
        <Box >
            <Box sx={{display:'inline-flex',mr:2}}>
                {tocs&&tocs.length?
            <Autocomplete
                    id="toc-select"
                    sx={{ width: 250,mr:3 }}
                    options={tocs}
                    value={toc}
                    autoHighlight
                    getOptionLabel={(option) => option.Description}
                    onChange={(event: any, newValue: DropdownModel|null) => {
                        setToc(newValue);
                      }}
                    renderOption={(props, option) => (
                        <Box key={option.Id} component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                            {option.Description}
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Choose a TOC"  
                            required                         
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-toc',
                            }}
                        />
                    )}
                />:null}
            </Box>
            <Button sx={{mt:4}} disabled={(toc==null)} variant="contained" onClick={saveEnvironment}>Save</Button>
        </Box>
    )
}